import { Slot } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Gift routes live under Account now. These routes only redirect legacy links
 * (emails, shared redemption links, bookmarks) to their new location.
 */
export default function GiftRedirectsLayout() {
  return <Slot />;
}
